import { ReactElement, useRef, useState } from "react";

interface BulkDropzoneProps {
  onFile: (file: File) => void;
}

/** Click-or-drag target for the filled-in template workbook. */
const BulkDropzone: React.FC<BulkDropzoneProps> = ({
  onFile,
}): ReactElement => {
  const input = useRef<HTMLInputElement>(null);
  const [dragging, setDragging] = useState(false);

  const take = (file?: File | null) => {
    if (file) onFile(file);
  };

  return (
    <div
      className={`dropzone${dragging ? " is-dragging" : ""}`}
      role="button"
      tabIndex={0}
      onClick={() => input.current?.click()}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") input.current?.click();
      }}
      onDragOver={(event) => {
        event.preventDefault();
        setDragging(true);
      }}
      onDragLeave={() => setDragging(false)}
      onDrop={(event) => {
        event.preventDefault();
        setDragging(false);
        take(event.dataTransfer.files?.[0]);
      }}
    >
      <span className="icon">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8Z" />
          <path d="M14 3v5h5" />
          <path d="M12 17v-5" />
          <path d="m9.8 14.2 2.2-2.2 2.2 2.2" />
        </svg>
      </span>
      <p className="primary">
        <span>Click to upload</span> or drag the filled template here
      </p>
      <p className="hint">
        Excel workbook (.xlsx, .xls) — up to 5 MB and 5,000 rows
      </p>
      <input
        ref={input}
        type="file"
        accept=".xlsx,.xls"
        style={{ display: "none" }}
        onChange={(event) => {
          take(event.target.files?.[0]);
          event.target.value = "";
        }}
      />
    </div>
  );
};

export default BulkDropzone;
